import CTable from './CTable.vue'
export default CTable
